import { theme } from 'lib/style';
import styled, { css, keyframes } from 'styled-components/macro';

export const ResellerAccordionTitle = styled.div`
  display: flex;
  padding: 25px;
  user-select: none;
`;

type IAccordionBodyProps = {
  isOpen: boolean;
};
export const ResellerAccordionBody = styled.div<IAccordionBodyProps>`
  display: none;
  max-height: 400px;
  height: auto;
  padding: 0 0 25px 0px;

  ${props =>
    props.isOpen &&
    css`
      display: block;
    `}
`;

export const DarkLabel = styled.label`
  display: flex;
  height: 20px;
  ${theme.fontNormal600}
  color: ${props => props.theme.colors.neutral[80]};
  font-size: 14px;
  line-height: 20px;
`;

export const LabelSkeleton = styled.div`
  height: 20px;
  width: 185px;
  border-radius: 4px;

  background-color: ${props => props.theme.colors.neutral[20]};
`;
export const CheckboxSkeleton = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 4px;

  background-color: ${props => props.theme.colors.neutral[20]};
`;

export const loading = keyframes`
 0% { transform: translateX(-150%) }
 50% { transform: translateX(-60%) }
 100% { transform: translateX(150%) }
`;
export const ShimmerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: ${loading} 2s infinite;
`;
export const Shimmer = styled.div`
  position: relative;
  top: 4px;
  width: 30%;
  height: calc(100% - 20px);
  background-color: ${props => props.theme.colors.white[80]};
  transform: skewX(-20deg);
  box-shadow: 0 0 30px 30px ${props => props.theme.colors.white[5]};
`;
